<template>
  <div class="content-box">
    <section class="md-section" data-chunk-index="0">
      <p style="text-align: center" data-md-start="0" data-md-end="10">
        <strong data-md-start="0" data-md-end="10"
          ><span data-md-start="2" data-md-end="8">用户隐私政策</span></strong
        >
      </p>
      <p data-md-start="12" data-md-end="54">
        <strong data-md-start="12" data-md-end="28"
          ><span data-md-start="14" data-md-end="26"
            >更新生效日期：2024年</span
          ></strong
        ><span data-md-start="28" data-md-end="29">&nbsp;</span
        ><strong data-md-start="29" data-md-end="35"
          ><span data-md-start="31" data-md-end="33">07</span></strong
        ><span data-md-start="35" data-md-end="36">&nbsp;</span
        ><strong data-md-start="36" data-md-end="41"
          ><span data-md-start="38" data-md-end="39">月</span></strong
        ><span data-md-start="41" data-md-end="42">&nbsp;</span
        ><strong data-md-start="42" data-md-end="48"
          ><span data-md-start="44" data-md-end="46">19</span></strong
        ><span data-md-start="48" data-md-end="49">&nbsp;</span
        ><strong data-md-start="49" data-md-end="54"
          ><span data-md-start="51" data-md-end="52">日</span></strong
        >
      </p>
      <p data-md-start="56" data-md-end="66">
        <strong data-md-start="56" data-md-end="66"
          ><span data-md-start="58" data-md-end="64">【阅读提示】</span></strong
        >
      </p>
      <p data-md-start="68" data-md-end="321">
        <strong data-md-start="68" data-md-end="92"
          ><span data-md-start="70" data-md-end="90"
            >1、欢迎您使用联动优势电子商务有限公司（</span
          ></strong
        ><span data-md-start="92" data-md-end="93">&nbsp;</span
        ><strong data-md-start="93" data-md-end="103"
          ><span data-md-start="95" data-md-end="101"
            >注册地位于：</span
          ></strong
        ><span data-md-start="103" data-md-end="104">&nbsp;</span
        ><strong data-md-start="104" data-md-end="135"
          ><span data-md-start="106" data-md-end="133"
            >山东省青岛市崂山区海尔路182-8号半岛国际大厦19楼</span
          ></strong
        ><span data-md-start="135" data-md-end="136">&nbsp;</span
        ><strong data-md-start="136" data-md-end="141"
          ><span data-md-start="138" data-md-end="139">，</span></strong
        ><span data-md-start="141" data-md-end="142">&nbsp;</span
        ><strong data-md-start="142" data-md-end="321"
          ><span data-md-start="144" data-md-end="319"
            >以下称&ldquo;我们&rdquo;）提供的相关服务！我们尊重并保护用户隐私，本政策包含了我们收集、存储、保护、使用您的个人信息的条款，请您完整地阅读本政策，以帮助您了解维护自己隐私权的方式。在您享用我们提供服务的过程中，由于服务的需要我们需要使用您的个人信息。我们深知保护个人信息责任重大，因此一直致力于保护用户的信息，并制定了本《用户隐私政策》（以下简称&ldquo;本政策&rdquo;）。</span
          ></strong
        >
      </p>
      <p data-md-start="323" data-md-end="527">
        <strong data-md-start="323" data-md-end="527"
          ><span data-md-start="325" data-md-end="525"
            >2、为了使您充分理解本政策，本政策中与您的权益存在或可能存在重大关系的条款，我们已采用粗体字进行标注提示您注意，请您务必仔细查看。我们收集、使用您的信息是出于遵守国家法律法规的规定以及向您提供服务及提升服务质量的目的（包括支持我们开发新产品或完善已有产品功能，为您和其他用户提供更为优质的服务），若您向我们提供了本政策中列明的信息，您可享受更多、更便捷的客户服务，使我们可以更好地保护您的账户安全等。</span
          ></strong
        >
      </p>
      <p data-md-start="529" data-md-end="715">
        <strong data-md-start="529" data-md-end="715"
          ><span data-md-start="531" data-md-end="713"
            >3、请您审慎阅读并选择接受或不接受本政策（未成年人应在监护人陪同下阅读），如您访问我们公司网站或移动设备客户端、POS终端、微信公众号并进行注册/登陆，或通过页面点击确认，或使用我们产品或接受我们服务，即视为您与我们已达成一致并同意接受本授权政策的所有条款，对本授权政策已充分理解，并完全清楚授权内容所产生的相关法律后果。我们将按照本政策收集、存储、使用您的信息。</span
          ></strong
        >
      </p>
      <p data-md-start="717" data-md-end="888">
        <strong data-md-start="717" data-md-end="888"
          ><span data-md-start="719" data-md-end="886"
            >4、本政策所称&ldquo;我们服务&rdquo;，包括但不限于您访问我们网站及其相关网站、或是下载、安装、使用我们各类客户端、或使用我们POS终端机具等产品，或使用我们提供的任一服务。本政策中的&ldquo;身份要素&rdquo;是指：我们用于识别用户身份的信息要素，例如：您在我们登录名、密码、短信校验码、电话号码、手机号码、证件号码及生物识别信息（例如：指纹信息、脸部信息）。</span
          ></strong
        >
      </p>
      <p data-md-start="890" data-md-end="956">
        <strong data-md-start="890" data-md-end="956"
          ><span data-md-start="892" data-md-end="954"
            >5、我们将努力采取合理的安全措施来保护您的个人信息，我们将采用行业内通行的方式及尽最大的商业努力来保护您个人敏感信息的安全。</span
          ></strong
        >
      </p>
      <p data-md-start="958" data-md-end="978">
        <strong data-md-start="958" data-md-end="978"
          ><span data-md-start="960" data-md-end="976"
            >本隐私政策将帮助您了解以下内容：</span
          ></strong
        >
      </p>
      <p data-md-start="980" data-md-end="999">
        <strong data-md-start="980" data-md-end="999"
          ><span data-md-start="982" data-md-end="997"
            >一、我们如何收集和使用个人信息</span
          ></strong
        >
      </p>
      <p data-md-start="1001" data-md-end="1020">
        <strong data-md-start="1001" data-md-end="1020"
          ><span data-md-start="1003" data-md-end="1018"
            >二、我们如何存储、保护个人信息</span
          ></strong
        >
      </p>
      <p data-md-start="1022" data-md-end="1032">
        <strong data-md-start="1022" data-md-end="1032"
          ><span data-md-start="1024" data-md-end="1030"
            >三、您的权利</span
          ></strong
        >
      </p>
      <p data-md-start="1034" data-md-end="1058">
        <strong data-md-start="1034" data-md-end="1058"
          ><span data-md-start="1036" data-md-end="1056"
            >四、我们如何共享、转让、公开披露个人信息</span
          ></strong
        >
      </p>
      <p data-md-start="1060" data-md-end="1074">
        <strong data-md-start="1060" data-md-end="1074"
          ><span data-md-start="1062" data-md-end="1072"
            >五、未成年人使用条款</span
          ></strong
        >
      </p>
      <p data-md-start="1076" data-md-end="1092">
        <strong data-md-start="1076" data-md-end="1092"
          ><span data-md-start="1078" data-md-end="1090"
            >六、隐私政策的修订和通知</span
          ></strong
        >
      </p>
      <p data-md-start="1094" data-md-end="1107">
        <strong data-md-start="1094" data-md-end="1107"
          ><span data-md-start="1096" data-md-end="1105"
            >七、如何与我们联系</span
          ></strong
        >
      </p>
      <p data-md-start="1109" data-md-end="1128">
        <strong data-md-start="1109" data-md-end="1128"
          ><span data-md-start="1111" data-md-end="1126"
            >一、我们如何收集和使用个人信息</span
          ></strong
        >
      </p>
      <p data-md-start="1130" data-md-end="1176">
        <strong data-md-start="1130" data-md-end="1176"
          ><span data-md-start="1132" data-md-end="1174"
            >我们将根据合法、正当、必要、&ldquo;最小化&rdquo;原则收集信息。我们收集或请您提供的信息将用于：</span
          ></strong
        >
      </p>
      <p data-md-start="1178" data-md-end="1196">
        <strong data-md-start="1178" data-md-end="1196"
          ><span data-md-start="1180" data-md-end="1194"
            >1.保障产品的基础正常运行；</span
          ></strong
        >
      </p>
      <p data-md-start="1198" data-md-end="1214">
        <strong data-md-start="1198" data-md-end="1214"
          ><span data-md-start="1200" data-md-end="1212"
            >2.实现各项功能和服务；</span
          ></strong
        >
      </p>
      <p data-md-start="1216" data-md-end="1233">
        <strong data-md-start="1216" data-md-end="1233"
          ><span data-md-start="1218" data-md-end="1231"
            >3.优化、改善产品和服务；</span
          ></strong
        >
      </p>
      <p data-md-start="1235" data-md-end="1257">
        <strong data-md-start="1235" data-md-end="1257"
          ><span data-md-start="1237" data-md-end="1255"
            >4.保障产品、服务以及用户使用安全；</span
          ></strong
        >
      </p>
      <p data-md-start="1259" data-md-end="1280">
        <strong data-md-start="1259" data-md-end="1280"
          ><span data-md-start="1261" data-md-end="1278"
            >5.遵循法律法规与国家标准的规定。</span
          ></strong
        >
      </p>
      <p data-md-start="1282" data-md-end="1298">
        <strong data-md-start="1282" data-md-end="1298"
          ><span data-md-start="1284" data-md-end="1296"
            >（一）个人信息授权、使用</span
          ></strong
        >
      </p>
      <p data-md-start="1300" data-md-end="1332">
        <strong data-md-start="1300" data-md-end="1332"
          ><span data-md-start="1302" data-md-end="1330"
            >1、依据法律法规及监管规定履行反洗钱义务及进行实名制管理</span
          ></strong
        >
      </p>
      <p data-md-start="1334" data-md-end="1666">
        <span data-md-start="1334" data-md-end="1374"
          >（1）
          在您注册账户或使用服务时，您需提供手机号码或者电子邮箱作为账户登录名。&nbsp;</span
        ><strong data-md-start="1374" data-md-end="1438"
          ><span data-md-start="1376" data-md-end="1436"
            >您需主动提供并收集您的身份基本信息，包括姓名、联系方式（电话）以及有效身份证件的种类、号码和有效期限、银行账号、电子邮箱</span
          ></strong
        ><span data-md-start="1438" data-md-end="1666"
          >&nbsp;，同时您授权并同意，我们将您的信息用于身份验证、客户服务、安全防范、诈骗监测、预防或禁止非法活动、存档和备份用途，确保我们向您提供的产品和服务的安全性，比较信息的准确性，并与第三方进行验证，例如，将您向&ldquo;我们&rdquo;提交的身份信息与合法的身份验证的服务机构进行交叉验证，以核实您身份的真实性、准确性。如您不提供前述信息，可能无法注册账户或无法使用相应服务。如您不提供前述信息，可能无法使用需要通过交叉验证后方可使用的部分服务，但不影响您使用我们提供的其他服务；</span
        >
      </p>
      <p data-md-start="1668" data-md-end="1809">
        <span data-md-start="1668" data-md-end="1719"
          >（2）我们需根据《支付机构反洗钱和反恐怖融资管理办法》等反洗钱相关法律法规及监管要求，提示您适时提供&nbsp;</span
        ><strong data-md-start="1719" data-md-end="1738"
          ><span data-md-start="1721" data-md-end="1736"
            >有效身份证件的彩色影印件或照片</span
          ></strong
        ><span data-md-start="1738" data-md-end="1809"
          >&nbsp;以供我们核对并留存；如您不提供前述彩色影印件、照片或不同意我们留存，可能无法使用与监管要求相关的部分服务，但不影响您使用我们提供的其他服务。</span
        >
      </p>
      <p data-md-start="1811" data-md-end="1826">
        <strong data-md-start="1811" data-md-end="1826"
          ><span data-md-start="1813" data-md-end="1824"
            >金融卡信息的收集和使用</span
          ></strong
        >
      </p>
      <p data-md-start="1828" data-md-end="1929">
        <span data-md-start="1828" data-md-end="1868"
          >当您使用银行卡绑定、交易结算、提现等相关功能时，我们可能收集您主动填写或提交的&nbsp;</span
        ><strong data-md-start="1868" data-md-end="1900"
          ><span data-md-start="1870" data-md-end="1898"
            >银行卡号、开户银行、持卡人姓名、预留手机号码等金融卡信息</span
          ></strong
        ><span data-md-start="1900" data-md-end="1929"
          >，用于银行卡绑定、身份核验、交易结算、资金收付及风险管理。</span
        >
      </p>
      <p data-md-start="1931" data-md-end="2020">
        <span data-md-start="1931" data-md-end="2020"
          >您使用相关功能并主动提交上述信息，即表示您已知悉并同意我们按照本政策收集、使用相关金融卡信息。如您拒绝提供相关信息，可能无法使用需要金融卡信息的相关功能，但不影响您使用其他功能。</span
        >
      </p>
      <p data-md-start="2022" data-md-end="2105">
        <span data-md-start="2022" data-md-end="2071"
          >2、为便于您查询交易状态或历史记录，也为了遵守法律法规的规定，&ldquo;我们&rdquo;会保存您使用我们服务产生的&nbsp;</span
        ><strong data-md-start="2071" data-md-end="2079"
          ><span data-md-start="2073" data-md-end="2077">交易信息</span></strong
        ><span data-md-start="2079" data-md-end="2105"
          >&nbsp;，并严格按照法律法规的规定对这些信息进行妥善保管。</span
        >
      </p>
      <p data-md-start="2107" data-md-end="2363">
        <span data-md-start="2107" data-md-end="2196"
          >3、为了充分保护您的账户安全，当您访问我们网站及其相关网站，或我们移动设备客户端、POS终端、微信公众号，或使用我们提供的支付相关功能/服务时，我们可能会记录您操作的相关信息，&nbsp;</span
        ><strong data-md-start="2196" data-md-end="2282"
          ><span data-md-start="2198" data-md-end="2280"
            >包括您的硬件序列号、设备mac地址、唯一设备识别码（deviceId、androidId、imei）、软件列表、软件使用记录、IP地址、登录密码、支付密码、数字证书</span
          ></strong
        ><span data-md-start="2282" data-md-end="2363"
          >&nbsp;，这些信息可帮助&ldquo;我们&rdquo;更好地识别您的身份以及保护您的账户安全，例如您的账户在可疑操作环境下登录，我们系统可能监控到您的账户风险，采取一些措施避免您的资金损失。</span
        >
      </p>
      <p data-md-start="2365" data-md-end="2424">
        <span data-md-start="2365" data-md-end="2424"
          >4、您授权&ldquo;我们&rdquo;向行政机关、事业单位、司法机关、监管部门、中国互联网金融协会等行业自律组织查询、打印、留存客户信息；</span
        >
      </p>
      <p data-md-start="2426" data-md-end="2649">
        <span data-md-start="2426" data-md-end="2649"
          >5、除上述信息外，&ldquo;我们&rdquo;还可能为了提供服务及改进服务质量的合理需要而收集您的其他信息，包括您与&ldquo;我们&rdquo;的客户服务团队联系时您提供的相关信息；您参与问卷调查时向&ldquo;我们&rdquo;发送的问卷答复信息；以及您与&ldquo;我们&rdquo;互动时&ldquo;我们&rdquo;收集的相关信息。与此同时，为提高您使用我们提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，&ldquo;我们&rdquo;可能会通过了解一些您的网络使用习惯、您常用的软件信息等手段来判断您账户的风险，并可能会记录一些&ldquo;我们&rdquo;认为有风险的URL。</span
        >
      </p>
      <p data-md-start="2651" data-md-end="2713">
        <span data-md-start="2651" data-md-end="2713"
          >6、为使您知晓自己使用我们服务的情况或了解我们的服务，你您授权&ldquo;我们&rdquo;向您发送服务状态的通知、营销活动及其他商业性电子信息。</span
        >
      </p>
      <p data-md-start="2715" data-md-end="2816">
        <span data-md-start="2715" data-md-end="2779"
          >7、为了使您了解我们产品的具体情况，您同意我们向您发送营销活动通知、商业性电子信息以及提供与您相关的广告以替代普遍投放的广告；&nbsp;</span
        ><strong data-md-start="2779" data-md-end="2797"
          ><span data-md-start="2781" data-md-end="2795"
            >如您不希望接收该类等信息，您</span
          ></strong
        ><span data-md-start="2797" data-md-end="2798">&nbsp;</span
        ><strong data-md-start="2798" data-md-end="2814"
          ><span data-md-start="2800" data-md-end="2812"
            >可以选择拒绝接收该类信息</span
          ></strong
        ><span data-md-start="2814" data-md-end="2816">&nbsp;。</span>
      </p>
      <p data-md-start="2818" data-md-end="2846">
        <span data-md-start="2818" data-md-end="2846"
          >8、您授权&ldquo;我们&rdquo;可邀请您参与有关我们产品和服务的调查。</span
        >
      </p>
      <p data-md-start="2848" data-md-end="2860">
        <span data-md-start="2848" data-md-end="2860"
          >9、经您许可的其他用途。</span
        >
      </p>
      <p data-md-start="2862" data-md-end="2998">
        <strong data-md-start="2862" data-md-end="2889"
          ><span data-md-start="2864" data-md-end="2887"
            >10、您理解并同意，您注册使用我们时，即授权&ldquo;</span
          ></strong
        ><span data-md-start="2889" data-md-end="2890">&nbsp;</span
        ><strong data-md-start="2890" data-md-end="2896"
          ><span data-md-start="2892" data-md-end="2894">我们</span></strong
        ><span data-md-start="2896" data-md-end="2897">&nbsp;</span
        ><strong data-md-start="2897" data-md-end="2902"
          ><span data-md-start="2899" data-md-end="2900">&rdquo;</span></strong
        ><span data-md-start="2902" data-md-end="2903">&nbsp;</span
        ><strong data-md-start="2903" data-md-end="2919"
          ><span data-md-start="2905" data-md-end="2917"
            >根据您所提供的各项信息及</span
          ></strong
        ><span data-md-start="2919" data-md-end="2920">&nbsp;</span
        ><strong data-md-start="2920" data-md-end="2925"
          ><span data-md-start="2922" data-md-end="2923">&ldquo;</span></strong
        ><span data-md-start="2925" data-md-end="2926">&nbsp;</span
        ><strong data-md-start="2926" data-md-end="2932"
          ><span data-md-start="2928" data-md-end="2930">我们</span></strong
        ><span data-md-start="2932" data-md-end="2933">&nbsp;</span
        ><strong data-md-start="2933" data-md-end="2938"
          ><span data-md-start="2935" data-md-end="2936">&rdquo;</span></strong
        ><span data-md-start="2938" data-md-end="2939">&nbsp;</span
        ><strong data-md-start="2939" data-md-end="2952"
          ><span data-md-start="2941" data-md-end="2950"
            >获得的信息评定您在</span
          ></strong
        ><span data-md-start="2952" data-md-end="2953">&nbsp;</span
        ><strong data-md-start="2953" data-md-end="2958"
          ><span data-md-start="2955" data-md-end="2956">&ldquo;</span></strong
        ><span data-md-start="2958" data-md-end="2959">&nbsp;</span
        ><strong data-md-start="2959" data-md-end="2965"
          ><span data-md-start="2961" data-md-end="2963">我们</span></strong
        ><span data-md-start="2965" data-md-end="2966">&nbsp;</span
        ><strong data-md-start="2966" data-md-end="2971"
          ><span data-md-start="2968" data-md-end="2969">&rdquo;</span></strong
        ><span data-md-start="2971" data-md-end="2972">&nbsp;</span
        ><strong data-md-start="2972" data-md-end="2998"
          ><span data-md-start="2974" data-md-end="2996"
            >的商户等级，或决定是否审核通过您的服务申请。</span
          ></strong
        >
      </p>
      <p data-md-start="3000" data-md-end="3024">
        <strong data-md-start="3000" data-md-end="3024"
          ><span data-md-start="3002" data-md-end="3022"
            >(二) 收集、使用个人信息目的变更的处理</span
          ></strong
        >
      </p>
      <p data-md-start="3026" data-md-end="3177">
        <span data-md-start="3026" data-md-end="3177"
          >请您了解，我们向您提供的功能和服务是不断更新和发展的，当新功能或服务与服务场景相关时，收集与使用的个人信息属于与原目的具有直接或合理关联。在与原目的无直接或合理关联的场景下，我们收集、使用您的个人信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。</span
        >
      </p>
      <p data-md-start="3179" data-md-end="3204">
        <strong data-md-start="3179" data-md-end="3204"
          ><span data-md-start="3181" data-md-end="3202"
            >（三）依法豁免征得同意收集和使用的个人信息</span
          ></strong
        >
      </p>
      <p data-md-start="3206" data-md-end="3261">
        <strong data-md-start="3206" data-md-end="3261"
          ><span data-md-start="3208" data-md-end="3259"
            >请您理解，根据相关法律法规及国家标准，以下情形中，我们收集、使用您的相关个人信息无需征求您的授权同意：</span
          ></strong
        >
      </p>
      <p data-md-start="3263" data-md-end="3320">
        <strong data-md-start="3263" data-md-end="3320"
          ><span data-md-start="3265" data-md-end="3318"
            >(1)
            与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公众知情等重大公共利益直接相关的；</span
          ></strong
        >
      </p>
      <p data-md-start="3322" data-md-end="3353">
        <strong data-md-start="3322" data-md-end="3353"
          ><span data-md-start="3324" data-md-end="3351"
            >(2) 与犯罪侦查、起诉、审判和判决执行等直接相关的；</span
          ></strong
        >
      </p>
      <p data-md-start="3355" data-md-end="3401">
        <strong data-md-start="3355" data-md-end="3401"
          ><span data-md-start="3357" data-md-end="3399"
            >(3)
            出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；</span
          ></strong
        >
      </p>
      <p data-md-start="3403" data-md-end="3432">
        <strong data-md-start="3403" data-md-end="3432"
          ><span data-md-start="3405" data-md-end="3430"
            >(4) 所收集的个人信息是您自行向社会公众公开的；</span
          ></strong
        >
      </p>
      <p data-md-start="3434" data-md-end="3480">
        <strong data-md-start="3434" data-md-end="3480"
          ><span data-md-start="3436" data-md-end="3478"
            >(5)
            从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span
          ></strong
        >
      </p>
      <p data-md-start="3482" data-md-end="3507">
        <strong data-md-start="3482" data-md-end="3507"
          ><span data-md-start="3484" data-md-end="3505"
            >(6) 根据您要求签订或履行合同所必需的；</span
          ></strong
        >
      </p>
      <p data-md-start="3509" data-md-end="3558">
        <strong data-md-start="3509" data-md-end="3558"
          ><span data-md-start="3511" data-md-end="3556"
            >(7)
            用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</span
          ></strong
        >
      </p>
      <p data-md-start="3560" data-md-end="3583">
        <strong data-md-start="3560" data-md-end="3583"
          ><span data-md-start="3562" data-md-end="3581"
            >(8) 为开展合法的新闻报道所必需的；</span
          ></strong
        >
      </p>
      <p data-md-start="3585" data-md-end="3652">
        <strong data-md-start="3585" data-md-end="3652"
          ><span data-md-start="3587" data-md-end="3650"
            >(9)
            出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span
          ></strong
        >
      </p>
      <p data-md-start="3654" data-md-end="3694">
        <strong data-md-start="3654" data-md-end="3694"
          ><span data-md-start="3656" data-md-end="3692"
            >(10)
            司法机关、政府监管部门、清算组织、行业自律协会要求提供的情形；</span
          ></strong
        >
      </p>
      <p data-md-start="3696" data-md-end="3717">
        <strong data-md-start="3696" data-md-end="3717"
          ><span data-md-start="3698" data-md-end="3715"
            >(11) 法律法规规定的其他情形。</span
          ></strong
        >
      </p>
      <p data-md-start="3719" data-md-end="3748">
        <strong data-md-start="3719" data-md-end="3748"
          ><span data-md-start="3721" data-md-end="3746"
            >（四）Cookie、Beacon、Proxy的使用</span
          ></strong
        >
      </p>
      <p data-md-start="3750" data-md-end="4348">
        <span data-md-start="3750" data-md-end="3910"
          >1、为使您获得更轻松的访问体验，您访问我们的网站、客户端或使用我们提供的服务/功能时，我可会通时小型数据文件识别你的身份，这么做可帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全状态。这些数据文件可能是Cookie、FashCookie，您的浏览器或关联应用程序提供的其他本地存储（以下简称&ldquo;Cookie&rdquo;）。&nbsp;</span
        ><strong data-md-start="3910" data-md-end="3944"
          ><span data-md-start="3912" data-md-end="3942"
            >请您理解，我们的某些服务只能通过使用Cookie才可得到实现</span
          ></strong
        ><span data-md-start="3944" data-md-end="3945">&nbsp;</span
        ><strong data-md-start="3945" data-md-end="3950"
          ><span data-md-start="3947" data-md-end="3948">。</span></strong
        ><span data-md-start="3950" data-md-end="3951">&nbsp;</span
        ><strong data-md-start="3951" data-md-end="3977"
          ><span data-md-start="3953" data-md-end="3975"
            >如的浏览或浏览器附加服务允许，您可以修改对C</span
          ></strong
        ><span data-md-start="3977" data-md-end="3978">&nbsp;</span
        ><strong data-md-start="3978" data-md-end="3984"
          ><span data-md-start="3980" data-md-end="3982">oo</span></strong
        ><span data-md-start="3984" data-md-end="3985">&nbsp;</span
        ><strong data-md-start="3985" data-md-end="3995"
          ><span data-md-start="3987" data-md-end="3993"
            >kie的接受</span
          ></strong
        ><span data-md-start="3995" data-md-end="3996">&nbsp;</span
        ><strong data-md-start="3996" data-md-end="4002"
          ><span data-md-start="3998" data-md-end="4000">程度</span></strong
        ><span data-md-start="4002" data-md-end="4003">&nbsp;</span
        ><strong data-md-start="4003" data-md-end="4028"
          ><span data-md-start="4005" data-md-end="4026"
            >或者拒绝Cookie，多数浏览器工具条中的</span
          ></strong
        ><span data-md-start="4028" data-md-end="4029">&nbsp;</span
        ><strong data-md-start="4029" data-md-end="4034"
          ><span data-md-start="4031" data-md-end="4032">&ldquo;</span></strong
        ><span data-md-start="4034" data-md-end="4035">&nbsp;</span
        ><strong data-md-start="4035" data-md-end="4041"
          ><span data-md-start="4037" data-md-end="4039">帮助</span></strong
        ><span data-md-start="4041" data-md-end="4042">&nbsp;</span
        ><strong data-md-start="4042" data-md-end="4047"
          ><span data-md-start="4044" data-md-end="4045">&rdquo;</span></strong
        ><span data-md-start="4047" data-md-end="4048">&nbsp;</span
        ><strong data-md-start="4048" data-md-end="4054"
          ><span data-md-start="4050" data-md-end="4052">部分</span></strong
        ><span data-md-start="4054" data-md-end="4055">&nbsp;</span
        ><strong data-md-start="4055" data-md-end="4060"
          ><span data-md-start="4057" data-md-end="4058">会</span></strong
        ><span data-md-start="4060" data-md-end="4061">&nbsp;</span
        ><strong data-md-start="4061" data-md-end="4082"
          ><span data-md-start="4063" data-md-end="4080"
            >告诉您怎样防止您的浏览器接受新的C</span
          ></strong
        ><span data-md-start="4082" data-md-end="4083">&nbsp;</span
        ><strong data-md-start="4083" data-md-end="4088"
          ><span data-md-start="4085" data-md-end="4086">o</span></strong
        ><span data-md-start="4088" data-md-end="4089">&nbsp;</span
        ><strong data-md-start="4089" data-md-end="4108"
          ><span data-md-start="4091" data-md-end="4106"
            >okie,怎样让您的浏览器在您</span
          ></strong
        ><span data-md-start="4108" data-md-end="4109">&nbsp;</span
        ><strong data-md-start="4109" data-md-end="4114"
          ><span data-md-start="4111" data-md-end="4112">收</span></strong
        ><span data-md-start="4114" data-md-end="4115">&nbsp;</span
        ><strong data-md-start="4115" data-md-end="4120"
          ><span data-md-start="4117" data-md-end="4118">到</span></strong
        ><span data-md-start="4120" data-md-end="4121">&nbsp;</span
        ><strong data-md-start="4121" data-md-end="4128"
          ><span data-md-start="4123" data-md-end="4126">一条新</span></strong
        ><span data-md-start="4128" data-md-end="4129">&nbsp;</span
        ><strong data-md-start="4129" data-md-end="4147"
          ><span data-md-start="4131" data-md-end="4145"
            >Cookie时通知您或者怎样</span
          ></strong
        ><span data-md-start="4147" data-md-end="4148">&nbsp;</span
        ><strong data-md-start="4148" data-md-end="4154"
          ><span data-md-start="4150" data-md-end="4152">彻底</span></strong
        ><span data-md-start="4154" data-md-end="4155">&nbsp;</span
        ><strong data-md-start="4155" data-md-end="4161"
          ><span data-md-start="4157" data-md-end="4159">关闭</span></strong
        ><span data-md-start="4161" data-md-end="4162">&nbsp;</span
        ><strong data-md-start="4162" data-md-end="4167"
          ><span data-md-start="4164" data-md-end="4165">C</span></strong
        ><span data-md-start="4167" data-md-end="4168">&nbsp;</span
        ><strong data-md-start="4168" data-md-end="4215"
          ><span data-md-start="4170" data-md-end="4213"
            >ookie。此外，您可以通过政变浏览器附加程序的设置，或通过访问提供商的网页，来关闭或</span
          ></strong
        ><span data-md-start="4215" data-md-end="4216">&nbsp;</span
        ><strong data-md-start="4216" data-md-end="4221"
          ><span data-md-start="4218" data-md-end="4219">删</span></strong
        ><span data-md-start="4221" data-md-end="4222">&nbsp;</span
        ><strong data-md-start="4222" data-md-end="4238"
          ><span data-md-start="4224" data-md-end="4236"
            >除浏览器附加程序使用的F</span
          ></strong
        ><span data-md-start="4238" data-md-end="4239">&nbsp;</span
        ><strong data-md-start="4239" data-md-end="4244"
          ><span data-md-start="4241" data-md-end="4242">l</span></strong
        ><span data-md-start="4244" data-md-end="4245">&nbsp;</span
        ><strong data-md-start="4245" data-md-end="4285"
          ><span data-md-start="4247" data-md-end="4283"
            >ashCookie及类似数据。但这一举动在某些情况下可能会影响您安全访问</span
          ></strong
        ><span data-md-start="4285" data-md-end="4286">&nbsp;</span
        ><strong data-md-start="4286" data-md-end="4293"
          ><span data-md-start="4288" data-md-end="4291">我们的</span></strong
        ><span data-md-start="4293" data-md-end="4294">&nbsp;</span
        ><strong data-md-start="4294" data-md-end="4300"
          ><span data-md-start="4296" data-md-end="4298">网站</span></strong
        ><span data-md-start="4300" data-md-end="4301">&nbsp;</span
        ><strong data-md-start="4301" data-md-end="4309"
          ><span data-md-start="4303" data-md-end="4307">/客户端</span></strong
        ><span data-md-start="4309" data-md-end="4310">&nbsp;</span
        ><strong data-md-start="4310" data-md-end="4317"
          ><span data-md-start="4312" data-md-end="4315">和使用</span></strong
        ><span data-md-start="4317" data-md-end="4318">&nbsp;</span
        ><strong data-md-start="4318" data-md-end="4324"
          ><span data-md-start="4320" data-md-end="4322">我们</span></strong
        ><span data-md-start="4324" data-md-end="4325">&nbsp;</span
        ><strong data-md-start="4325" data-md-end="4334"
          ><span data-md-start="4327" data-md-end="4332"
            >提供的服务</span
          ></strong
        ><span data-md-start="4334" data-md-end="4335">&nbsp;</span
        ><strong data-md-start="4335" data-md-end="4342"
          ><span data-md-start="4337" data-md-end="4340">/功能</span></strong
        ><span data-md-start="4342" data-md-end="4343">&nbsp;</span
        ><strong data-md-start="4343" data-md-end="4348"
          ><span data-md-start="4345" data-md-end="4346">。</span></strong
        >
      </p>
    </section>
    <section class="md-section" data-chunk-index="1">
      <p data-md-start="0" data-md-end="205">
        <strong data-md-start="0" data-md-end="5"
          ><span data-md-start="2" data-md-end="3">2</span></strong
        ><span data-md-start="5" data-md-end="6">&nbsp;</span
        ><strong data-md-start="6" data-md-end="33"
          ><span data-md-start="8" data-md-end="31"
            >、我们网站上还可能包含一些电子图像（以下简称&ldquo;</span
          ></strong
        ><span data-md-start="33" data-md-end="34">&nbsp;</span
        ><strong data-md-start="34" data-md-end="44"
          ><span data-md-start="36" data-md-end="42">网络Beac</span></strong
        ><span data-md-start="44" data-md-end="45">&nbsp;</span
        ><strong data-md-start="45" data-md-end="50"
          ><span data-md-start="47" data-md-end="48">o</span></strong
        ><span data-md-start="50" data-md-end="51">&nbsp;</span
        ><strong data-md-start="51" data-md-end="56"
          ><span data-md-start="53" data-md-end="54">n</span></strong
        ><span data-md-start="56" data-md-end="57">&nbsp;</span
        ><strong data-md-start="57" data-md-end="64"
          ><span data-md-start="59" data-md-end="62">&rdquo;），</span></strong
        ><span data-md-start="64" data-md-end="65">&nbsp;</span
        ><strong data-md-start="65" data-md-end="77"
          ><span data-md-start="67" data-md-end="75">使用网络Beac</span></strong
        ><span data-md-start="77" data-md-end="78">&nbsp;</span
        ><strong data-md-start="78" data-md-end="83"
          ><span data-md-start="80" data-md-end="81">o</span></strong
        ><span data-md-start="83" data-md-end="84">&nbsp;</span
        ><strong data-md-start="84" data-md-end="91"
          ><span data-md-start="86" data-md-end="89">n可以</span></strong
        ><span data-md-start="91" data-md-end="92">&nbsp;</span
        ><strong data-md-start="92" data-md-end="121"
          ><span data-md-start="94" data-md-end="119"
            >帮助网站计算浏览网页的用户或访问某些Cookie，</span
          ></strong
        ><span data-md-start="121" data-md-end="122">&nbsp;</span
        ><strong data-md-start="122" data-md-end="136"
          ><span data-md-start="124" data-md-end="134"
            >我们会通过网Beac</span
          ></strong
        ><span data-md-start="136" data-md-end="137">&nbsp;</span
        ><strong data-md-start="137" data-md-end="142"
          ><span data-md-start="139" data-md-end="140">o</span></strong
        ><span data-md-start="142" data-md-end="143">&nbsp;</span
        ><strong data-md-start="143" data-md-end="151"
          ><span data-md-start="145" data-md-end="149">n收集您</span></strong
        ><span data-md-start="151" data-md-end="152">&nbsp;</span
        ><strong data-md-start="152" data-md-end="166"
          ><span data-md-start="154" data-md-end="164"
            >浏览网页活动的信息。</span
          ></strong
        ><span data-md-start="166" data-md-end="205"
          >&nbsp;(您访问的页面地址、您先前访问的援引页面的位置、您的浏览环境以及显示设定)。</span
        >
      </p>
      <p data-md-start="207" data-md-end="645">
        <strong data-md-start="207" data-md-end="223"
          ><span data-md-start="209" data-md-end="221"
            >3、如您通过我们的网站或</span
          ></strong
        ><span data-md-start="223" data-md-end="224">&nbsp;</span
        ><strong data-md-start="224" data-md-end="237"
          ><span data-md-start="226" data-md-end="235"
            >APP，使用了由第</span
          ></strong
        ><span data-md-start="237" data-md-end="238">&nbsp;</span
        ><strong data-md-start="238" data-md-end="243"
          ><span data-md-start="240" data-md-end="241">三</span></strong
        ><span data-md-start="243" data-md-end="244">&nbsp;</span
        ><strong data-md-start="244" data-md-end="251"
          ><span data-md-start="246" data-md-end="249">方而非</span></strong
        ><span data-md-start="251" data-md-end="252">&nbsp;</span
        ><strong data-md-start="252" data-md-end="258"
          ><span data-md-start="254" data-md-end="256">我们</span></strong
        ><span data-md-start="258" data-md-end="259">&nbsp;</span
        ><strong data-md-start="259" data-md-end="268"
          ><span data-md-start="261" data-md-end="266">提供的服务</span></strong
        ><span data-md-start="268" data-md-end="269">&nbsp;</span
        ><strong data-md-start="269" data-md-end="276"
          ><span data-md-start="271" data-md-end="274">/功能</span></strong
        ><span data-md-start="276" data-md-end="277">&nbsp;</span
        ><strong data-md-start="277" data-md-end="332"
          ><span data-md-start="279" data-md-end="330"
            >时，为尽力确保您的账号安全，使您获得更安全的访问体验，我们可能会使用专用的网络协议及代理技术(以下简称</span
          ></strong
        ><span data-md-start="332" data-md-end="333">&nbsp;</span
        ><strong data-md-start="333" data-md-end="338"
          ><span data-md-start="335" data-md-end="336">&ldquo;</span></strong
        ><span data-md-start="338" data-md-end="339">&nbsp;</span
        ><strong data-md-start="339" data-md-end="347"
          ><span data-md-start="341" data-md-end="345">Prox</span></strong
        ><span data-md-start="347" data-md-end="348">&nbsp;</span
        ><strong data-md-start="348" data-md-end="353"
          ><span data-md-start="350" data-md-end="351">y</span></strong
        ><span data-md-start="353" data-md-end="354">&nbsp;</span
        ><strong data-md-start="354" data-md-end="360"
          ><span data-md-start="356" data-md-end="358">技术</span></strong
        ><span data-md-start="360" data-md-end="361">&nbsp;</span
        ><strong data-md-start="361" data-md-end="367"
          ><span data-md-start="363" data-md-end="365">&rdquo;)</span></strong
        ><span data-md-start="367" data-md-end="368">&nbsp;</span
        ><strong data-md-start="368" data-md-end="379"
          ><span data-md-start="370" data-md-end="377">。使用Prox</span></strong
        ><span data-md-start="379" data-md-end="380">&nbsp;</span
        ><strong data-md-start="380" data-md-end="385"
          ><span data-md-start="382" data-md-end="383">y</span></strong
        ><span data-md-start="385" data-md-end="386">&nbsp;</span
        ><strong data-md-start="386" data-md-end="400"
          ><span data-md-start="388" data-md-end="398"
            >技术，可以帮助您识别</span
          ></strong
        ><span data-md-start="400" data-md-end="401">&nbsp;</span
        ><strong data-md-start="401" data-md-end="406"
          ><span data-md-start="403" data-md-end="404">到</span></strong
        ><span data-md-start="406" data-md-end="407">&nbsp;</span
        ><strong data-md-start="407" data-md-end="432"
          ><span data-md-start="409" data-md-end="430"
            >我们已知的高风险站点，减少由此引起的钓鱼、</span
          ></strong
        ><span data-md-start="432" data-md-end="433">&nbsp;</span
        ><strong data-md-start="433" data-md-end="439"
          ><span data-md-start="435" data-md-end="437">账号</span></strong
        ><span data-md-start="439" data-md-end="440">&nbsp;</span
        ><strong data-md-start="440" data-md-end="450"
          ><span data-md-start="442" data-md-end="448"
            >泄露等风险，</span
          ></strong
        ><span data-md-start="450" data-md-end="451">&nbsp;</span
        ><strong data-md-start="451" data-md-end="457"
          ><span data-md-start="453" data-md-end="455">同时</span></strong
        ><span data-md-start="457" data-md-end="458">&nbsp;</span
        ><strong data-md-start="458" data-md-end="484"
          ><span data-md-start="460" data-md-end="482"
            >更有利于保您和第三方的共同权益，阻止不法分子</span
          ></strong
        ><span data-md-start="484" data-md-end="485">&nbsp;</span
        ><strong data-md-start="485" data-md-end="490"
          ><span data-md-start="487" data-md-end="488">篡</span></strong
        ><span data-md-start="490" data-md-end="491">&nbsp;</span
        ><strong data-md-start="491" data-md-end="507"
          ><span data-md-start="493" data-md-end="505"
            >改您和您希望访问的第三方</span
          ></strong
        ><span data-md-start="507" data-md-end="508">&nbsp;</span
        ><strong data-md-start="508" data-md-end="527"
          ><span data-md-start="511" data-md-end="524"
            >之间正常服务内容，包括**</span
          ></strong
        ><span data-md-start="528" data-md-end="556"
          >:不安全路由器、非法基站等引起的广告注入、非法内容**&nbsp;</span
        ><strong data-md-start="557" data-md-end="562"
          ><span data-md-start="559" data-md-end="560">篡</span></strong
        ><span data-md-start="562" data-md-end="563">&nbsp;</span
        ><strong data-md-start="563" data-md-end="568"
          ><span data-md-start="565" data-md-end="566">改</span></strong
        ><span data-md-start="568" data-md-end="569">&nbsp;</span
        ><strong data-md-start="569" data-md-end="574"
          ><span data-md-start="571" data-md-end="572">。</span></strong
        ><span data-md-start="574" data-md-end="575">&nbsp;</span
        ><strong data-md-start="575" data-md-end="600"
          ><span data-md-start="577" data-md-end="598"
            >在此过程中，我们也可能会获得和保存您设备的</span
          ></strong
        ><span data-md-start="600" data-md-end="601">&nbsp;</span
        ><strong data-md-start="601" data-md-end="606"
          ><span data-md-start="603" data-md-end="604">I</span></strong
        ><span data-md-start="606" data-md-end="607">&nbsp;</span
        ><strong data-md-start="607" data-md-end="617"
          ><span data-md-start="609" data-md-end="615"
            >P地址、硬件</span
          ></strong
        ><span data-md-start="617" data-md-end="618">&nbsp;</span
        ><strong data-md-start="618" data-md-end="623"
          ><span data-md-start="620" data-md-end="621">I</span></strong
        ><span data-md-start="623" data-md-end="624">&nbsp;</span
        ><strong data-md-start="624" data-md-end="639"
          ><span data-md-start="626" data-md-end="637"
            >D以及您访问的页面位置</span
          ></strong
        ><span data-md-start="639" data-md-end="640">&nbsp;</span
        ><strong data-md-start="640" data-md-end="645"
          ><span data-md-start="642" data-md-end="643">。</span></strong
        >
      </p>
      <p data-md-start="647" data-md-end="664">
        <strong data-md-start="647" data-md-end="664"
          ><span data-md-start="649" data-md-end="662"
            >（五）有关第三方责任的声明</span
          ></strong
        >
      </p>
      <p data-md-start="666" data-md-end="1035">
        <strong data-md-start="666" data-md-end="714"
          ><span data-md-start="668" data-md-end="712"
            >1、请您注意，您的交易向对方、您的交易相方、您访问的第三方网站经营者、通过本客户端所接入</span
          ></strong
        ><span data-md-start="714" data-md-end="715">&nbsp;</span
        ><strong data-md-start="715" data-md-end="727"
          ><span data-md-start="717" data-md-end="725"
            >的第三方服务和由</span
          ></strong
        ><span data-md-start="727" data-md-end="728">&nbsp;</span
        ><strong data-md-start="728" data-md-end="734"
          ><span data-md-start="730" data-md-end="732">我们</span></strong
        ><span data-md-start="734" data-md-end="735">&nbsp;</span
        ><strong data-md-start="735" data-md-end="769"
          ><span data-md-start="737" data-md-end="767"
            >接收您的个人信息的第三方可能有自己的隐私权保护政策;当您查看</span
          ></strong
        ><span data-md-start="769" data-md-end="770">&nbsp;</span
        ><strong data-md-start="770" data-md-end="776"
          ><span data-md-start="772" data-md-end="774">使用</span></strong
        ><span data-md-start="776" data-md-end="777">&nbsp;</span
        ><strong data-md-start="777" data-md-end="782"
          ><span data-md-start="779" data-md-end="780">第</span></strong
        ><span data-md-start="782" data-md-end="783">&nbsp;</span
        ><strong data-md-start="783" data-md-end="788"
          ><span data-md-start="785" data-md-end="786">三</span></strong
        ><span data-md-start="788" data-md-end="789">&nbsp;</span
        ><strong data-md-start="789" data-md-end="803"
          ><span data-md-start="791" data-md-end="801"
            >方创建的网页或使用第</span
          ></strong
        ><span data-md-start="803" data-md-end="804">&nbsp;</span
        ><strong data-md-start="804" data-md-end="809"
          ><span data-md-start="806" data-md-end="807">三</span></strong
        ><span data-md-start="809" data-md-end="810">&nbsp;</span
        ><strong data-md-start="810" data-md-end="822"
          ><span data-md-start="812" data-md-end="820"
            >方开发的应用程序</span
          ></strong
        ><span data-md-start="822" data-md-end="823">&nbsp;</span
        ><strong data-md-start="823" data-md-end="832"
          ><span data-md-start="825" data-md-end="830">/功能服务</span></strong
        ><span data-md-start="832" data-md-end="833">&nbsp;</span
        ><strong data-md-start="833" data-md-end="900"
          ><span data-md-start="835" data-md-end="898"
            >时，这些第三方可能会放置他们自己的Cookie或网络Beaon,这ookie或网络Beacon不受我们的控制，且它们的使用不受</span
          ></strong
        ><span data-md-start="900" data-md-end="901">&nbsp;</span
        ><strong data-md-start="901" data-md-end="906"
          ><span data-md-start="903" data-md-end="904">本</span></strong
        ><span data-md-start="906" data-md-end="907">&nbsp;</span
        ><strong data-md-start="907" data-md-end="969"
          ><span data-md-start="909" data-md-end="967"
            >政策的约束，我们会努力去要求这些主体对您的个人信息采取保护措施，建议您与他们联系以获得关于他们的隐私权政策的详细情况</span
          ></strong
        ><span data-md-start="969" data-md-end="970">&nbsp;</span
        ><strong data-md-start="970" data-md-end="975"
          ><span data-md-start="972" data-md-end="973">。</span></strong
        ><span data-md-start="975" data-md-end="976">&nbsp;</span
        ><strong data-md-start="976" data-md-end="1011"
          ><span data-md-start="978" data-md-end="1009"
            >如您发现这些第三方创建的网页或第三方开发的应用程序存在风险时，</span
          ></strong
        ><span data-md-start="1011" data-md-end="1012">&nbsp;</span
        ><strong data-md-start="1012" data-md-end="1035"
          ><span data-md-start="1014" data-md-end="1033"
            >建议您终止相关操作以保护您的合法权益。</span
          ></strong
        >
      </p>
      <p data-md-start="1037" data-md-end="1188">
        <strong data-md-start="1037" data-md-end="1188"
          ><span data-md-start="1039" data-md-end="1186"
            >2、您知晓并同意，本客户端中部分服务/功能需要由第三方共同为您提供（例如：通知推送、定位功能），为此，本客户端内会嵌入第三方的软件工具开发包（以下简称&ldquo;SDK&rdquo;）或其他类似的应用程序我们会对SDK或其他类似的应用程序进行严格的安全监测，并要求第三方采取严格的数据保护措施，切实保障您的合法权益。</span
          ></strong
        >
      </p>
      <p data-md-start="1190" data-md-end="1259">
        <strong data-md-start="1190" data-md-end="1259"
          ><span data-md-start="1192" data-md-end="1257"
            >3、本客户端相关第三方SDK见下表，您在此知晓并同意，当您使用第三方相关服务/功能时，第三方将基于该服务/功能而收集您的相关信息；</span
          ></strong
        >
      </p>
      <p data-md-start="1261" data-md-end="1278">
        <strong data-md-start="1261" data-md-end="1278"
          ><span data-md-start="1263" data-md-end="1276"
            >(1)友盟统计分析SDK；</span
          ></strong
        >
      </p>
      <p data-md-start="1280" data-md-end="1296">
        <span data-md-start="1280" data-md-end="1296"
          >目的：进行APP运营统计与分析；</span
        >
      </p>
      <p data-md-start="1298" data-md-end="1317">
        <span data-md-start="1298" data-md-end="1317"
          >运营方：友盟同欣（北京）科技有限公司；</span
        >
      </p>
      <p data-md-start="1319" data-md-end="1403">
        <span data-md-start="1319" data-md-end="1403"
          >收集个人信息类型：设备信息（IMEI/MAC/Android
          ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息。</span
        >
      </p>
      <p data-md-start="1405" data-md-end="1500">
        <span data-md-start="1405" data-md-end="1428"
          >隐私权政策链接：友盟同欣（北京）科技有限公司&nbsp;</span
        ><a
          href="https://www.umeng.com/page/policy"
          data-md-start="1428"
          data-md-end="1498"
          ><span data-md-start="1429" data-md-end="1462"
            >https://www.umeng.com/page/policy</span
          ></a
        ><span data-md-start="1498" data-md-end="1500">&nbsp;。</span>
      </p>
      <p data-md-start="1502" data-md-end="1519">
        <strong data-md-start="1502" data-md-end="1519"
          ><span data-md-start="1504" data-md-end="1517"
            >(2)友盟消息推送SDK；</span
          ></strong
        >
      </p>
      <p data-md-start="1521" data-md-end="1543">
        <span data-md-start="1521" data-md-end="1543"
          >SDK服务商：友盟同欣（北京）科技有限公司；</span
        >
      </p>
      <p data-md-start="1545" data-md-end="1629">
        <span data-md-start="1545" data-md-end="1629"
          >收集个人信息类型：设备信息（IMEI/MAC/Android
          ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息。</span
        >
      </p>
      <p data-md-start="1631" data-md-end="1726">
        <span data-md-start="1631" data-md-end="1654"
          >隐私权政策链接：友盟同欣（北京）科技有限公司&nbsp;</span
        ><a
          href="https://www.umeng.com/page/policy"
          data-md-start="1654"
          data-md-end="1724"
          ><span data-md-start="1655" data-md-end="1688"
            >https://www.umeng.com/page/policy</span
          ></a
        ><span data-md-start="1724" data-md-end="1726">&nbsp;。</span>
      </p>
      <p data-md-start="1728" data-md-end="1741">
        <strong data-md-start="1728" data-md-end="1741"
          ><span data-md-start="1730" data-md-end="1739"
            >(3)友盟SDK；</span
          ></strong
        >
      </p>
      <p data-md-start="1743" data-md-end="1762">
        <span data-md-start="1743" data-md-end="1762"
          >服务类型：应用性能监控平台U-APM；</span
        >
      </p>
      <p data-md-start="1764" data-md-end="1783">
        <span data-md-start="1764" data-md-end="1783"
          >运营方：友盟同欣（北京）科技有限公司；</span
        >
      </p>
      <p data-md-start="1785" data-md-end="1931">
        <span data-md-start="1785" data-md-end="1931"
          >收集个人信息类型：个人信息字段采集：我们采集设备信息（IMEI/MAC/Android
          ID/OAID/IDFA/OpenUDID/GUID/SIM卡IMSI/ICCID等），用于唯一标识设备，以便提供设备应用性能监控服务；通过采集位置信息提供反作弊服务，剔除作弊设备，排查应用性能崩溃原因。</span
        >
      </p>
      <p data-md-start="1933" data-md-end="1951">
        <strong data-md-start="1933" data-md-end="1951"
          ><span data-md-start="1935" data-md-end="1949"
            >(4)七牛云对象存储API；</span
          ></strong
        >
      </p>
      <p data-md-start="1953" data-md-end="1973">
        <span data-md-start="1953" data-md-end="1973"
          >场景：用户实名认证，添加用户个人银行卡；</span
        >
      </p>
      <p data-md-start="1975" data-md-end="2008">
        <span data-md-start="1975" data-md-end="2008"
          >用途：用于用户实名认证，身份证、银行卡图片存储，意见反馈图片存储；</span
        >
      </p>
      <p data-md-start="2010" data-md-end="2047">
        <span data-md-start="2010" data-md-end="2047"
          >个人信息字段：涉及个人信息：身份证照片、银行卡照片、用户上传的反馈图片等；</span
        >
      </p>
      <p data-md-start="2049" data-md-end="2070">
        <span data-md-start="2049" data-md-end="2070"
          >机构/隐私政策：上海七牛信息技术有限公司，</span
        >
      </p>
      <p data-md-start="2072" data-md-end="2154">
        <a
          href="https://www.qiniu.com/en/privacy-right"
          data-md-start="2072"
          data-md-end="2152"
          ><span data-md-start="2073" data-md-end="2111"
            >https://www.qiniu.com/en/privacy-right</span
          ></a
        ><span data-md-start="2152" data-md-end="2154">&nbsp;。</span>
      </p>
      <p data-md-start="2156" data-md-end="2177">
        <strong data-md-start="2156" data-md-end="2177"
          ><span data-md-start="2158" data-md-end="2175"
            >(5)腾讯云慧眼人脸核身 SDK；</span
          ></strong
        >
      </p>
      <p data-md-start="2179" data-md-end="2199">
        <span data-md-start="2179" data-md-end="2199"
          >提供方：腾讯云计算（北京）有限责任公司；</span
        >
      </p>
      <p data-md-start="2201" data-md-end="2215">
        <span data-md-start="2201" data-md-end="2215"
          >处理目的：用于实人实名认证；</span
        >
      </p>
      <p data-md-start="2217" data-md-end="2306">
        <span data-md-start="2217" data-md-end="2306"
          >处理方式：（1）对人脸视频进行活体检测，将姓名、身份证号、人脸图片与&ldquo;互联网+可信身份认证平台&rdquo;等核验机构存储的信息进行比对核验，得出一致或不一致的结果，并返回认证结果给开发者。</span
        >
      </p>
      <p data-md-start="2308" data-md-end="2373">
        <span data-md-start="2308" data-md-end="2373"
          >（2）采集设备信息并进行去标识化处理后，用于检测认证设备实时风险，得到风险等级用于认证结果的判断，增强版还会将认证结果返回开发者。</span
        >
      </p>
      <p data-md-start="2375" data-md-end="2435">
        <span data-md-start="2375" data-md-end="2435"
          >处理个人信息类型：身份证照片或者姓名和身份证号码等身份信息、人脸视频和照片和设备信息（不同版本收集的设备信息有所不同）：</span
        >
      </p>
      <p data-md-start="2437" data-md-end="2479">
        <span data-md-start="2437" data-md-end="2479"
          >Android 版将收集内核版本、CPU
          信息、机型、系统版本、设备制造商、运营商。</span
        >
      </p>
      <p data-md-start="2481" data-md-end="2511">
        <span data-md-start="2481" data-md-end="2511"
          >IOS 版将收集 GUID、蜂窝网络 IP、WIFI IP。</span
        >
      </p>
      <p data-md-start="2513" data-md-end="2563">
        <span data-md-start="2513" data-md-end="2563"
          >申请的权限：摄像头、网络、读取存储权限、麦克风（仅 SDK、H5 需要
          ，其中麦克风仅基础版需要）；</span
        >
      </p>
      <p data-md-start="2565" data-md-end="2590">
        <strong data-md-start="2565" data-md-end="2590"
          ><span data-md-start="2567" data-md-end="2588"
            >(6)腾讯优图Faceln人脸核身SDK；</span
          ></strong
        >
      </p>
      <p data-md-start="2592" data-md-end="2616">
        <span data-md-start="2592" data-md-end="2616"
          >提供方的公司名称：深圳市腾讯计算机系统有限公司；</span
        >
      </p>
      <p data-md-start="2618" data-md-end="2629">
        <span data-md-start="2618" data-md-end="2629"
          >产品/类型：人脸识别；</span
        >
      </p>
      <p data-md-start="2631" data-md-end="2647">
        <span data-md-start="2631" data-md-end="2647"
          >使用目的：活体检测实现实人认证；</span
        >
      </p>
      <p data-md-start="2649" data-md-end="2684">
        <span data-md-start="2649" data-md-end="2684"
          >使用场景：用户在使用第三方开发者应用中与人脸核验/验证相关的功能场景时</span
        >
      </p>
      <p data-md-start="2686" data-md-end="2701">
        <span data-md-start="2686" data-md-end="2701"
          >共享信息名称：人脸视频及照片；</span
        >
      </p>
      <p data-md-start="2703" data-md-end="2714">
        <span data-md-start="2703" data-md-end="2714">共享方式：SDK集成；</span>
      </p>
      <p data-md-start="2716" data-md-end="2738">
        <strong data-md-start="2716" data-md-end="2738"
          ><span data-md-start="2718" data-md-end="2736"
            >(7)腾讯图灵盾人脸防攻击 SDK；</span
          ></strong
        >
      </p>
      <p data-md-start="2740" data-md-end="2764">
        <span data-md-start="2740" data-md-end="2764"
          >提供方的公司名称：深圳市腾讯计算机系统有限公司；</span
        >
      </p>
      <p data-md-start="2766" data-md-end="2777">
        <span data-md-start="2766" data-md-end="2777"
          >产品/类型：安全风控；</span
        >
      </p>
      <p data-md-start="2779" data-md-end="2793">
        <span data-md-start="2779" data-md-end="2793"
          >使用目的：实人认证安全风控；</span
        >
      </p>
      <p data-md-start="2795" data-md-end="2830">
        <span data-md-start="2795" data-md-end="2830"
          >使用场景：用户在使用第三方开发者应用中与人脸核验/验证相关的功能场景时</span
        >
      </p>
      <p data-md-start="2832" data-md-end="2885">
        <span data-md-start="2832" data-md-end="2885"
          >共享信息名称：1. 系统设置、系统属性、网络状态、设备型号、操作系统、IP
          地址、相机（相机参数、接口）；</span
        >
      </p>
      <ol data-md-start="2887" data-md-end="2947">
        <li data-md-start="2887" data-md-end="2947">
          <span data-md-start="2890" data-md-end="2947"
            >不同系统版本还共享以下信息：Android：硬件序列号
            OAID、部分存储文件路径；iOS：运营商信息、iDFV；</span
          >
        </li>
      </ol>
      <p data-md-start="2949" data-md-end="2960">
        <span data-md-start="2949" data-md-end="2960">共享方式：SDK集成；</span>
      </p>
      <p data-md-start="2962" data-md-end="2994">
        <strong data-md-start="2962" data-md-end="2994"
          ><span data-md-start="2964" data-md-end="2992"
            >(8)Bugly SDK（仅 Android 端使用）；</span
          ></strong
        >
      </p>
      <p data-md-start="2996" data-md-end="3020">
        <span data-md-start="2996" data-md-end="3020"
          >提供方的公司名称：深圳市腾讯计算机系统有限公司；</span
        >
      </p>
      <p data-md-start="3022" data-md-end="3038">
        <span data-md-start="3022" data-md-end="3038"
          >产品/类型：Crash 监控类；</span
        >
      </p>
      <p data-md-start="3040" data-md-end="3073">
        <span data-md-start="3040" data-md-end="3073"
          >使用目的：本 SDK 运行时对发生的故障问题进行排查、分析、解决；</span
        >
      </p>
      <p data-md-start="3075" data-md-end="3141">
        <span data-md-start="3075" data-md-end="3141"
          >使用场景：（1）用户在使用第三方开发者应用中与人脸核验/验证相关的功能场景时（2）定位并解决用户在使用本
          SDK 服务时遇到的问题；</span
        >
      </p>
      <p data-md-start="3143" data-md-end="3283">
        <span data-md-start="3143" data-md-end="3283"
          >共享信息名称：Android 端：手机型号、手机品牌、 Android
          系统版本、Android 系统 API 等级、厂商系统版本、CPU 架构类型、设备是否
          root、磁盘空间占用大小、sdcard
          空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和
          PID；</span
        >
      </p>
      <p data-md-start="3285" data-md-end="3296">
        <span data-md-start="3285" data-md-end="3296">共享方式：SDK集成；</span>
      </p>
      <p data-md-start="3298" data-md-end="3317">
        <strong data-md-start="3298" data-md-end="3317"
          ><span data-md-start="3300" data-md-end="3315"
            >二、我们如何存储、保护个人信息</span
          ></strong
        >
      </p>
      <p data-md-start="3319" data-md-end="3397">
        <strong data-md-start="3319" data-md-end="3324"
          ><span data-md-start="3321" data-md-end="3322">1</span></strong
        ><span data-md-start="3324" data-md-end="3325">&nbsp;</span
        ><strong data-md-start="3325" data-md-end="3356"
          ><span data-md-start="3327" data-md-end="3354"
            >、我们建立专门的管理制度、流程和组织以保障信息的安全。</span
          ></strong
        ><span data-md-start="3356" data-md-end="3357">&nbsp;</span
        ><strong data-md-start="3357" data-md-end="3397"
          ><span data-md-start="3359" data-md-end="3395"
            >例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。</span
          ></strong
        >
      </p>
      <p data-md-start="3399" data-md-end="3604">
        <span data-md-start="3399" data-md-end="3604"
          >2、为保障您的信息安全，我们对收集、存储的用户个人信息及行为将严格保密，&ldquo;我们&rdquo;努力在现有的技术水平下采取各种合理必要的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。&ldquo;我们&rdquo;对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密政策，监控他们的操作情况等措施。</span
        >
      </p>
      <p data-md-start="3606" data-md-end="3675">
        <span data-md-start="3606" data-md-end="3675"
          >3、&ldquo;我们&rdquo;会按现有技术提供相应的安全措施来保护您的信息，
          提供合理的安全保障，
          我们将在任何时候尽力做到使您的信息不被泄漏、毁损或丢失。</span
        >
      </p>
      <p data-md-start="3677" data-md-end="3739">
        <span data-md-start="3677" data-md-end="3739"
          >4、您的信息存储于中国的服务器上，为了安全及备份的需要，&ldquo;我们&rdquo;可能将您的信息和资料储存到&ldquo;我们&rdquo;或其他合作公司的服务器上。</span
        >
      </p>
      <p data-md-start="3741" data-md-end="3812">
        <span data-md-start="3741" data-md-end="3812"
          >5、我们会按照相关法律、法规、部门规章规定的期限，存储用户个人信息；法律、法规、部门规章没有明确规定的，按照行业规范及业务需要的期限进行保存。</span
        >
      </p>
      <p data-md-start="3814" data-md-end="3871">
        <span data-md-start="3814" data-md-end="3871"
          >6、并请您理解并明白，由于存在的各种各样的恶意手段，即便我们尽力采取上述措施，您的信息仍有可能被泄漏、毁损或灭失。</span
        >
      </p>
      <p data-md-start="3873" data-md-end="3906">
        <span data-md-start="3873" data-md-end="3906"
          >7、您应审慎选择通过第三方使用我们服务，并妥善保护好您的个人信息。</span
        >
      </p>
      <p data-md-start="3908" data-md-end="4216">
        <strong data-md-start="3908" data-md-end="3913"
          ><span data-md-start="3910" data-md-end="3911">8</span></strong
        ><span data-md-start="3913" data-md-end="3914">&nbsp;</span
        ><strong data-md-start="3914" data-md-end="3939"
          ><span data-md-start="3916" data-md-end="3937"
            >、在使用我们服务时，请妥善保管好您的用户名</span
          ></strong
        ><span data-md-start="3939" data-md-end="3940">&nbsp;</span
        ><strong data-md-start="3940" data-md-end="3945"
          ><span data-md-start="3942" data-md-end="3943">/</span></strong
        ><span data-md-start="3945" data-md-end="3946">&nbsp;</span
        ><strong data-md-start="3946" data-md-end="3952"
          ><span data-md-start="3948" data-md-end="3950">帐户</span></strong
        ><span data-md-start="3952" data-md-end="3953">&nbsp;</span
        ><strong data-md-start="3953" data-md-end="3958"
          ><span data-md-start="3955" data-md-end="3956">/</span></strong
        ><span data-md-start="3958" data-md-end="3959">&nbsp;</span
        ><strong data-md-start="3959" data-md-end="4137"
          ><span data-md-start="3961" data-md-end="4135"
            >账户、账号及其对应密码，以及您就特定途用设置的其他密码（例如支付密码），我们会通过您的账户及其密码来识别您的身份，接收您作出的指令。一旦您泄漏了账号及其密码，您可能会丢失您的信息，并可能产生对您不利的法律后果。如您怀疑或发现账号及其密码因任何原因已经或将受到泄漏时，您应该立即和我们取得联系，但在我们知悉此种情况和采取行动前，我们对此不负任何责任。</span
          ></strong
        ><span data-md-start="4137" data-md-end="4138">&nbsp;</span
        ><strong data-md-start="4138" data-md-end="4216"
          ><span data-md-start="4140" data-md-end="4214"
            >我们及关联公司采用合理安全措施（包括管理、技术和物理方面安全措施）来保护您提供的信息，防止信息遭到未经授权的访问、公开披露、使用、修改、破坏或丢失。</span
          ></strong
        >
      </p>
    </section>
    <section class="md-section" data-chunk-index="2">
      <p data-md-start="0" data-md-end="236">
        <span data-md-start="0" data-md-end="236"
          >9、尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。</span
        >
      </p>
      <p data-md-start="238" data-md-end="485">
        <span data-md-start="238" data-md-end="485"
          >10、我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，
          努力阻止该等安全事件的影响和后果扩大。一旦不幸发生信息安全事件（泄露、丢失等）后，
          我们将按照法律法规的要求，采取合理、有效的方式（如以推送通知、短信等形式告知您，
          难以逐一告知时，我们会采取合理、有效的方式发布公告）及时向您告知：
          安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、
          您可自主防范和降低风险的建议、对您的补救措施等。
          同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。</span
        >
      </p>
      <p data-md-start="487" data-md-end="606">
        <span data-md-start="487" data-md-end="606"
          >11、我们谨此特别提醒您，本政策提供的个人信息保护措施仅适用于&ldquo;我们&rdquo;提供的相应服务，
          一旦您离开我们的服务范围，浏览或使用其他网站、服务及内容资源，
          我们将无法保护您在使用我们服务之外的软件、网站提交的任何个人信息，
          无论您登录、浏览。</span
        >
      </p>
      <p data-md-start="608" data-md-end="614">
        <span data-md-start="608" data-md-end="614">三、您的权利</span>
      </p>
      <p data-md-start="616" data-md-end="696">
        <span data-md-start="616" data-md-end="696"
          >我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的访问、
          修改（更新或更正）、删除以及撤回授权同意的权利，
          以使您拥有充分的能力保障您的隐私和安全。</span
        >
      </p>
      <p data-md-start="698" data-md-end="712">
        <span data-md-start="698" data-md-end="712"
          >（一）管理、撤回授权您的信息</span
        >
      </p>
      <p data-md-start="714" data-md-end="778">
        <span data-md-start="714" data-md-end="778"
          >您还有权撤回对您个人信息使用的同意，您可以通过删除信息、
          或者其他类似功能和服务中授权公司继续收集个人信息的范围或撤回您的授权。</span
        >
      </p>
      <p data-md-start="780" data-md-end="902">
        <span data-md-start="780" data-md-end="902"
          >请您理解，特定的业务功能和服务将需要您的信息才能得以完成，
          当您撤回同意或授权后，公司无法继续为您提供撤回同意或授权所对应的功能和服务，
          也不再处理您相应的个人信息。但您撤回同意或授权的决定，
          不会影响公司此前基于您的授权而开展的个人信息处理。</span
        >
      </p>
      <p data-md-start="904" data-md-end="911">
        <span data-md-start="904" data-md-end="911">（二）投诉举报</span>
      </p>
      <p data-md-start="913" data-md-end="986">
        <span data-md-start="913" data-md-end="986"
          >您可以按照我们公示的制度进行投诉或举报。
          如果您认为您的个人信息权利可能受到侵害，
          或者发现侵害个人信息权利的线索，您可以通过客服电话与我们联系。</span
        >
      </p>
      <p data-md-start="988" data-md-end="997">
        <span data-md-start="988" data-md-end="997">（三）访问隐私政策</span>
      </p>
      <p data-md-start="999" data-md-end="1020">
        <span data-md-start="999" data-md-end="1020"
          >您可以在注册页面查看本隐私政策的全部内容。</span
        >
      </p>
      <p data-md-start="1022" data-md-end="1035">
        <span data-md-start="1022" data-md-end="1035"
          >（四）停止运营向您告知权利</span
        >
      </p>
      <p data-md-start="1037" data-md-end="1103">
        <span data-md-start="1037" data-md-end="1103"
          >当我们的产品或服务发生停止运营的情形时，我们将以推送通知、
          公告等形式通知您，并在合理的期限内删除您的个人信息或进行去标识化化处理。</span
        >
      </p>
      <p data-md-start="1105" data-md-end="1129">
        <strong data-md-start="1105" data-md-end="1129"
          ><span data-md-start="1107" data-md-end="1127"
            >四、我们如何共享、转让、公开披露个人信息</span
          ></strong
        >
      </p>
      <p data-md-start="1131" data-md-end="1149">
        <strong data-md-start="1131" data-md-end="1149"
          ><span data-md-start="1133" data-md-end="1147"
            >（一） 个人信息的共享、转让</span
          ></strong
        >
      </p>
      <p data-md-start="1151" data-md-end="1247">
        <strong data-md-start="1151" data-md-end="1247"
          ><span data-md-start="1153" data-md-end="1245"
            >我们不会主动向第三方共享、转让您的个人信息，除非我们直接或确认第三方征得了您的事先授权同意，或者共享、转让的个人信息是去标识化处理后的信息，且共享第三方无法通过此类信息识别到您的身份。</span
          ></strong
        >
      </p>
      <p data-md-start="1249" data-md-end="1279">
        <strong data-md-start="1249" data-md-end="1279"
          ><span data-md-start="1251" data-md-end="1277"
            >1、在下列情况下，我们可能会以上述方式共享个人信息：</span
          ></strong
        >
      </p>
      <p data-md-start="1281" data-md-end="1431">
        <strong data-md-start="1281" data-md-end="1328"
          ><span data-md-start="1283" data-md-end="1326"
            >(1)
            用户身份验证、客户服务、安全防范、欺诈监测、存档和备份以及其他安全保障性用途，</span
          ></strong
        ><span data-md-start="1328" data-md-end="1431"
          >&nbsp;确保我们向您提供的产品和服务的安全性；如果我们监测到您使用我们的服务用于欺诈或非法目的，我们将会采取相应措施停止向您提供服务；我们不会将我们存储在分析软件中的信息与您在应用程序中提供的个人身份信息相结合。</span
        >
      </p>
      <p data-md-start="1433" data-md-end="1501">
        <strong data-md-start="1433" data-md-end="1501"
          ><span data-md-start="1435" data-md-end="1499"
            >(2)
            开展审计，协助执行法律法规，响应或履行公安部门等监管机构的监管要求，以及遵守适用法律法规项下或向相关监管机构承诺的义务；</span
          ></strong
        >
      </p>
      <p data-md-start="1503" data-md-end="1578">
        <strong data-md-start="1503" data-md-end="1578"
          ><span data-md-start="1505" data-md-end="1576"
            >(3)
            如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的同意。</span
          ></strong
        >
      </p>
      <p data-md-start="1580" data-md-end="1608">
        <strong data-md-start="1580" data-md-end="1608"
          ><span data-md-start="1582" data-md-end="1606"
            >2、对共享个人信息第三方主体的谨慎评估及责任约束</span
          ></strong
        >
      </p>
      <p data-md-start="1610" data-md-end="1693">
        <span data-md-start="1610" data-md-end="1641"
          >(1) 经您同意，我们只会与第三方共享实现目的所必要的信息。&nbsp;</span
        ><strong data-md-start="1641" data-md-end="1693"
          ><span data-md-start="1643" data-md-end="1691"
            >如果第三方因业务需要，确需超出前述授权范围使用个人信息的，该第三方将需再次征求您的自主选择同意。</span
          ></strong
        >
      </p>
      <p data-md-start="1695" data-md-end="1791">
        <strong data-md-start="1695" data-md-end="1791"
          ><span data-md-start="1697" data-md-end="1789"
            >(2)
            对我们与之共享您个人信息的第三方，该些第三方会与我们签订保密协议。同时，我们会对其数据安全能力与环境进行评估并要求第三方以不低于本隐私政策所要求的保密和安全措施来处理该些信息。</span
          ></strong
        >
      </p>
      <p data-md-start="1793" data-md-end="1815">
        <strong data-md-start="1793" data-md-end="1815"
          ><span data-md-start="1795" data-md-end="1813"
            >3、收购、兼并、重组时个人信息的转让</span
          ></strong
        >
      </p>
      <p data-md-start="1817" data-md-end="1948">
        <span data-md-start="1817" data-md-end="1878"
          >随着我们业务的持续发展，我们有可能进行合并、
          收购、资产转让等交易，您的个人信息有可能因此而被转移。
          在发生前述变更时，&nbsp;</span
        ><strong data-md-start="1878" data-md-end="1948"
          ><span data-md-start="1880" data-md-end="1946"
            >我们将按照法律法规及不低于本指引所要求的标准继续保护或要求新的控制者继续保护您的个人信息，否则我们将要求继受方重新征得您的授权同意。</span
          ></strong
        >
      </p>
      <p data-md-start="1950" data-md-end="1967">
        <strong data-md-start="1950" data-md-end="1967"
          ><span data-md-start="1952" data-md-end="1965"
            >（二） 个人信息的公开披露</span
          ></strong
        >
      </p>
      <p data-md-start="1969" data-md-end="2067">
        <strong data-md-start="1969" data-md-end="2067"
          ><span data-md-start="1971" data-md-end="2065"
            >目前，我们不会主动共享或转让您的个人信息至第三方，
            如存在其他共享或转让您的个人信息或您需要我们将您的个人信息共享或转让至第三方情形时，
            我们会直接或确认第三方征得您对上述行为的明示同意。</span
          ></strong
        >
      </p>
      <p data-md-start="2069" data-md-end="2148">
        <strong data-md-start="2069" data-md-end="2148"
          ><span data-md-start="2071" data-md-end="2146"
            >我们不会对外公开披露其收集的个人信息，如必须公开披露时，
            我们会向您告知此次公开披露的目的、
            披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。</span
          ></strong
        >
      </p>
      <p data-md-start="2150" data-md-end="2181">
        <strong data-md-start="2150" data-md-end="2181"
          ><span data-md-start="2152" data-md-end="2179"
            >（三） 依法豁免征得同意共享、转让、公开披露的个人信息</span
          ></strong
        >
      </p>
      <p data-md-start="2183" data-md-end="2249">
        <strong data-md-start="2183" data-md-end="2249"
          ><span data-md-start="2185" data-md-end="2247"
            >请您理解，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意：</span
          ></strong
        >
      </p>
      <p data-md-start="2251" data-md-end="2274">
        <strong data-md-start="2251" data-md-end="2274"
          ><span data-md-start="2253" data-md-end="2272"
            >(1)与国家安全、国防安全直接相关的；</span
          ></strong
        >
      </p>
      <p data-md-start="2276" data-md-end="2306">
        <strong data-md-start="2276" data-md-end="2306"
          ><span data-md-start="2278" data-md-end="2304"
            >(2)与公共安全、公共卫生、重大公共利益直接相关的；</span
          ></strong
        >
      </p>
      <p data-md-start="2308" data-md-end="2338">
        <strong data-md-start="2308" data-md-end="2338"
          ><span data-md-start="2310" data-md-end="2336"
            >(3)与犯罪侦查、起诉、审判和判决执行等直接相关的；</span
          ></strong
        >
      </p>
      <p data-md-start="2340" data-md-end="2388">
        <strong data-md-start="2340" data-md-end="2388"
          ><span data-md-start="2342" data-md-end="2386"
            >(4)
            出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span
          ></strong
        >
      </p>
      <p data-md-start="2390" data-md-end="2418">
        <strong data-md-start="2390" data-md-end="2418"
          ><span data-md-start="2392" data-md-end="2416"
            >(5)个人信息主体自行向社会公众公开的个人信息；</span
          ></strong
        >
      </p>
      <p data-md-start="2420" data-md-end="2466">
        <strong data-md-start="2420" data-md-end="2466"
          ><span data-md-start="2422" data-md-end="2464"
            >(6)
            从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span
          ></strong
        >
      </p>
      <p data-md-start="2468" data-md-end="2480">
        <strong data-md-start="2468" data-md-end="2480"
          ><span data-md-start="2470" data-md-end="2478"
            >五、未成年人保护</span
          ></strong
        >
      </p>
      <p data-md-start="2482" data-md-end="2627">
        <strong data-md-start="2482" data-md-end="2487"
          ><span data-md-start="2484" data-md-end="2485">1</span></strong
        ><span data-md-start="2487" data-md-end="2488">&nbsp;</span
        ><strong data-md-start="2488" data-md-end="2493"
          ><span data-md-start="2490" data-md-end="2491">、</span></strong
        ><span data-md-start="2493" data-md-end="2494">&nbsp;</span
        ><strong data-md-start="2494" data-md-end="2627"
          ><span data-md-start="2496" data-md-end="2625"
            >&ldquo;我们&rdquo;仅向具备完全民事行为能力主体提供服务，如您为无民事行为能力人或为限制民事行为能力的未成年人，请告知您的监护人，同时，请您不要向&ldquo;我们&rdquo;提供任何个人信息，也不要使用任何服务。一经发现，我们有权拒绝提供全部服务，注销相关账户，也不会留存您提供的任何信息。</span
          ></strong
        >
      </p>
      <p data-md-start="2629" data-md-end="2796">
        <strong data-md-start="2629" data-md-end="2634"
          ><span data-md-start="2631" data-md-end="2632">2</span></strong
        ><span data-md-start="2634" data-md-end="2635">&nbsp;</span
        ><strong data-md-start="2635" data-md-end="2663"
          ><span data-md-start="2637" data-md-end="2661"
            >、我们非常重视对未成年人信息的保护。如果您是未满</span
          ></strong
        ><span data-md-start="2663" data-md-end="2664">&nbsp;</span
        ><strong data-md-start="2664" data-md-end="2670"
          ><span data-md-start="2666" data-md-end="2668">18</span></strong
        ><span data-md-start="2670" data-md-end="2671">&nbsp;</span
        ><strong data-md-start="2671" data-md-end="2711"
          ><span data-md-start="2673" data-md-end="2709"
            >周岁的未成年人，您应立即停止操作，在您父母或其他监护人监护、指导下停止、</span
          ></strong
        ><span data-md-start="2711" data-md-end="2712">&nbsp;</span
        ><strong data-md-start="2712" data-md-end="2722"
          ><span data-md-start="2714" data-md-end="2720"
            >退出注册流程</span
          ></strong
        ><span data-md-start="2722" data-md-end="2723">&nbsp;</span
        ><strong data-md-start="2723" data-md-end="2728"
          ><span data-md-start="2725" data-md-end="2726">。</span></strong
        ><span data-md-start="2728" data-md-end="2729">&nbsp;</span
        ><strong data-md-start="2729" data-md-end="2796"
          ><span data-md-start="2731" data-md-end="2794"
            >若您无法顺利退出相关操作流程，请您或您的监护人及时联系通知我们，我们将提供必要的协助，对您的账户进行后台注销，并删除相关信息。</span
          ></strong
        >
      </p>
      <p data-md-start="2798" data-md-end="2961">
        <strong data-md-start="2798" data-md-end="2803"
          ><span data-md-start="2800" data-md-end="2801">3</span></strong
        ><span data-md-start="2803" data-md-end="2804">&nbsp;</span
        ><strong data-md-start="2804" data-md-end="2844"
          ><span data-md-start="2806" data-md-end="2842"
            >、我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、</span
          ></strong
        ><span data-md-start="2844" data-md-end="2845">&nbsp;</span
        ><strong data-md-start="2845" data-md-end="2881"
          ><span data-md-start="2847" data-md-end="2879"
            >父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、</span
          ></strong
        ><span data-md-start="2881" data-md-end="2882">&nbsp;</span
        ><strong data-md-start="2882" data-md-end="2901"
          ><span data-md-start="2884" data-md-end="2899"
            >共享或披露未成年人的个人信息；</span
          ></strong
        ><span data-md-start="2901" data-md-end="2902">&nbsp;</span
        ><strong data-md-start="2902" data-md-end="2943"
          ><span data-md-start="2904" data-md-end="2941"
            >如果我们发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，</span
          ></strong
        ><span data-md-start="2943" data-md-end="2944">&nbsp;</span
        ><strong data-md-start="2944" data-md-end="2961"
          ><span data-md-start="2946" data-md-end="2959"
            >则会设法尽快删除相关信息。</span
          ></strong
        >
      </p>
      <p data-md-start="2963" data-md-end="3032">
        <strong data-md-start="2963" data-md-end="2981"
          ><span data-md-start="2965" data-md-end="2979"
            >4、若您是未成年人的监护人，</span
          ></strong
        ><span data-md-start="2981" data-md-end="2982">&nbsp;</span
        ><strong data-md-start="2982" data-md-end="3009"
          ><span data-md-start="2984" data-md-end="3007"
            >当您对所监护的未成年人的个人信息有任何疑问时，</span
          ></strong
        ><span data-md-start="3009" data-md-end="3010">&nbsp;</span
        ><strong data-md-start="3010" data-md-end="3032"
          ><span data-md-start="3012" data-md-end="3030"
            >请通过本政策公示的联系方式联系我们。</span
          ></strong
        >
      </p>
      <p data-md-start="3034" data-md-end="3050">
        <strong data-md-start="3034" data-md-end="3050"
          ><span data-md-start="3036" data-md-end="3048"
            >六、隐私政策的修订和通知</span
          ></strong
        >
      </p>
      <p data-md-start="3052" data-md-end="3171">
        <strong data-md-start="3052" data-md-end="3057"
          ><span data-md-start="3054" data-md-end="3055">1</span></strong
        ><span data-md-start="3057" data-md-end="3058">&nbsp;</span
        ><strong data-md-start="3058" data-md-end="3090"
          ><span data-md-start="3060" data-md-end="3088"
            >、随着我们服务的不断提升，本政策的内容也可能会不时更新，</span
          ></strong
        ><span data-md-start="3090" data-md-end="3091">&nbsp;</span
        ><strong data-md-start="3091" data-md-end="3125"
          ><span data-md-start="3093" data-md-end="3123"
            >该等修订构成本隐私政策的一部分并具有等同于本隐私政策的效力。</span
          ></strong
        ><span data-md-start="3125" data-md-end="3126">&nbsp;</span
        ><strong data-md-start="3126" data-md-end="3139"
          ><span data-md-start="3128" data-md-end="3137"
            >但未经您明确同意，</span
          ></strong
        ><span data-md-start="3139" data-md-end="3140">&nbsp;</span
        ><strong data-md-start="3140" data-md-end="3171"
          ><span data-md-start="3142" data-md-end="3169"
            >我们不会削减您依据当前生效的本隐私政策所应享受的权利。</span
          ></strong
        >
      </p>
      <p data-md-start="3173" data-md-end="3292">
        <strong data-md-start="3173" data-md-end="3178"
          ><span data-md-start="3175" data-md-end="3176">2</span></strong
        ><span data-md-start="3178" data-md-end="3179">&nbsp;</span
        ><strong data-md-start="3179" data-md-end="3206"
          ><span data-md-start="3181" data-md-end="3204"
            >、本政策更新后，我们会在服务平台发出更新版本，</span
          ></strong
        ><span data-md-start="3206" data-md-end="3207">&nbsp;</span
        ><strong data-md-start="3207" data-md-end="3237"
          ><span data-md-start="3209" data-md-end="3235"
            >并在更新后的条款生效前以适当的方式提醒您更新的内容，</span
          ></strong
        ><span data-md-start="3237" data-md-end="3238">&nbsp;</span
        ><strong data-md-start="3238" data-md-end="3258"
          ><span data-md-start="3240" data-md-end="3256"
            >以便您及时了解本政策的最新版本。</span
          ></strong
        ><span data-md-start="3258" data-md-end="3259">&nbsp;</span
        ><strong data-md-start="3259" data-md-end="3292"
          ><span data-md-start="3261" data-md-end="3290"
            >我们鼓励您时常登陆、查看服务页面以了解我们最新的隐私政策。</span
          ></strong
        >
      </p>
      <p data-md-start="3294" data-md-end="3502">
        <strong data-md-start="3294" data-md-end="3299"
          ><span data-md-start="3296" data-md-end="3297">3</span></strong
        ><span data-md-start="3299" data-md-end="3300">&nbsp;</span
        ><strong data-md-start="3300" data-md-end="3333"
          ><span data-md-start="3302" data-md-end="3331"
            >、若您在我们公布变更后的本政策后继续使用我们所提供的服务，</span
          ></strong
        ><span data-md-start="3333" data-md-end="3334">&nbsp;</span
        ><strong data-md-start="3334" data-md-end="3369"
          ><span data-md-start="3336" data-md-end="3367"
            >则表示您已充分阅读、理解并接受经该等修订后的本政策的全部内容，</span
          ></strong
        ><span data-md-start="3369" data-md-end="3370">&nbsp;</span
        ><strong data-md-start="3370" data-md-end="3388"
          ><span data-md-start="3372" data-md-end="3386"
            >也将遵循该等内容使用本政策；</span
          ></strong
        ><span data-md-start="3388" data-md-end="3389">&nbsp;</span
        ><strong data-md-start="3389" data-md-end="3414"
          ><span data-md-start="3391" data-md-end="3412"
            >若您不同意该等经修订后的本政策的任何内容，</span
          ></strong
        ><span data-md-start="3414" data-md-end="3415">&nbsp;</span
        ><strong data-md-start="3415" data-md-end="3433"
          ><span data-md-start="3417" data-md-end="3431"
            >您即应选择停止使用相应服务。</span
          ></strong
        ><span data-md-start="3433" data-md-end="3434">&nbsp;</span
        ><strong data-md-start="3434" data-md-end="3459"
          ><span data-md-start="3436" data-md-end="3457"
            >但如果更新的服务内容需要采集您的地理位置、</span
          ></strong
        ><span data-md-start="3459" data-md-end="3460">&nbsp;</span
        ><strong data-md-start="3460" data-md-end="3481"
          ><span data-md-start="3462" data-md-end="3479"
            >联系方式、身份信息等个人敏感信息，</span
          ></strong
        ><span data-md-start="3481" data-md-end="3482">&nbsp;</span
        ><strong data-md-start="3482" data-md-end="3502"
          ><span data-md-start="3484" data-md-end="3500"
            >仍会再次以显著方式征求您的同意。</span
          ></strong
        >
      </p>
      <p data-md-start="3504" data-md-end="3592">
        <strong data-md-start="3504" data-md-end="3509"
          ><span data-md-start="3506" data-md-end="3507">4</span></strong
        ><span data-md-start="3509" data-md-end="3510">&nbsp;</span
        ><strong data-md-start="3510" data-md-end="3535"
          ><span data-md-start="3512" data-md-end="3533"
            >、对于重大变更，我们还会提供更为显著的通知</span
          ></strong
        ><span data-md-start="3535" data-md-end="3536">&nbsp;</span
        ><strong data-md-start="3536" data-md-end="3555"
          ><span data-md-start="3538" data-md-end="3553"
            >（我们会通过包括但不限于短信、</span
          ></strong
        ><span data-md-start="3555" data-md-end="3556">&nbsp;</span
        ><strong data-md-start="3556" data-md-end="3592"
          ><span data-md-start="3558" data-md-end="3590"
            >私信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。</span
          ></strong
        >
      </p>
      <p data-md-start="3594" data-md-end="3624">
        <strong data-md-start="3594" data-md-end="3599"
          ><span data-md-start="3596" data-md-end="3597">5</span></strong
        ><span data-md-start="3599" data-md-end="3600">&nbsp;</span
        ><strong data-md-start="3600" data-md-end="3624"
          ><span data-md-start="3602" data-md-end="3622"
            >、本隐私政策所指的重大变更包括但不限于：</span
          ></strong
        >
      </p>
      <p data-md-start="3626" data-md-end="3685">
        <strong data-md-start="3626" data-md-end="3633"
          ><span data-md-start="3628" data-md-end="3631">(1)</span></strong
        ><span data-md-start="3633" data-md-end="3634">&nbsp;</span
        ><strong data-md-start="3634" data-md-end="3685"
          ><span data-md-start="3636" data-md-end="3683"
            >我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息的类型、个人信息的使用方式等；</span
          ></strong
        >
      </p>
      <p data-md-start="3687" data-md-end="3741">
        <strong data-md-start="3687" data-md-end="3694"
          ><span data-md-start="3689" data-md-end="3692">(2)</span></strong
        ><span data-md-start="3694" data-md-end="3695">&nbsp;</span
        ><strong data-md-start="3695" data-md-end="3741"
          ><span data-md-start="3697" data-md-end="3739"
            >我们在公司结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有变更等；</span
          ></strong
        >
      </p>
      <p data-md-start="3743" data-md-end="3779">
        <strong data-md-start="3743" data-md-end="3750"
          ><span data-md-start="3745" data-md-end="3748">(3)</span></strong
        ><span data-md-start="3750" data-md-end="3751">&nbsp;</span
        ><strong data-md-start="3751" data-md-end="3779"
          ><span data-md-start="3753" data-md-end="3777"
            >个人信息共享、转让或公开披露的主要对象发生变化；</span
          ></strong
        >
      </p>
      <p data-md-start="3781" data-md-end="3820">
        <strong data-md-start="3781" data-md-end="3788"
          ><span data-md-start="3783" data-md-end="3786">(4)</span></strong
        ><span data-md-start="3788" data-md-end="3789">&nbsp;</span
        ><strong data-md-start="3789" data-md-end="3820"
          ><span data-md-start="3791" data-md-end="3818"
            >您参与个人信息处理方面的权利及其行使方式发生重大变化；</span
          ></strong
        >
      </p>
      <p data-md-start="3822" data-md-end="3867">
        <strong data-md-start="3822" data-md-end="3829"
          ><span data-md-start="3824" data-md-end="3827">(5)</span></strong
        ><span data-md-start="3829" data-md-end="3830">&nbsp;</span
        ><strong data-md-start="3830" data-md-end="3867"
          ><span data-md-start="3832" data-md-end="3865"
            >我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时。</span
          ></strong
        >
      </p>
      <p data-md-start="3869" data-md-end="3884">
        <strong data-md-start="3869" data-md-end="3884"
          ><span data-md-start="3871" data-md-end="3882"
            >七、对第三方责任的声明</span
          ></strong
        >
      </p>
      <p data-md-start="3886" data-md-end="4160">
        <strong data-md-start="3886" data-md-end="3891"
          ><span data-md-start="3888" data-md-end="3889">1</span></strong
        ><span data-md-start="3891" data-md-end="3892">&nbsp;</span
        ><strong data-md-start="3892" data-md-end="3937"
          ><span data-md-start="3894" data-md-end="3935"
            >、请您注意，您的交易相对方、您访问的第三方网站经营者、您使用的第三方服务提供者和由</span
          ></strong
        ><span data-md-start="3937" data-md-end="3938">&nbsp;</span
        ><strong data-md-start="3938" data-md-end="3943"
          ><span data-md-start="3940" data-md-end="3941">&ldquo;</span></strong
        ><span data-md-start="3943" data-md-end="3944">&nbsp;</span
        ><strong data-md-start="3944" data-md-end="3950"
          ><span data-md-start="3946" data-md-end="3948">我们</span></strong
        ><span data-md-start="3950" data-md-end="3951">&nbsp;</span
        ><strong data-md-start="3951" data-md-end="3956"
          ><span data-md-start="3953" data-md-end="3954">&rdquo;</span></strong
        ><span data-md-start="3956" data-md-end="3957">&nbsp;</span
        ><strong data-md-start="3957" data-md-end="4031"
          ><span data-md-start="3959" data-md-end="4029"
            >处接受您的个人信息的第三方可能有自己的隐私权保护规则；当您查看第三方创建的网页或使用第三方开发的应用程序时，可能会发现该网页或应用程序放置的</span
          ></strong
        ><span data-md-start="4031" data-md-end="4032">&nbsp;</span
        ><strong data-md-start="4032" data-md-end="4042"
          ><span data-md-start="4034" data-md-end="4040">Cookie</span></strong
        ><span data-md-start="4042" data-md-end="4043">&nbsp;</span
        ><strong data-md-start="4043" data-md-end="4071"
          ><span data-md-start="4045" data-md-end="4069"
            >或像素标签。同样，这些第三方可能会放置他们自己的</span
          ></strong
        ><span data-md-start="4071" data-md-end="4072">&nbsp;</span
        ><strong data-md-start="4072" data-md-end="4082"
          ><span data-md-start="4074" data-md-end="4080">Cookie</span></strong
        ><span data-md-start="4082" data-md-end="4083">&nbsp;</span
        ><strong data-md-start="4083" data-md-end="4095"
          ><span data-md-start="4085" data-md-end="4093"
            >或像素标签，这些</span
          ></strong
        ><span data-md-start="4095" data-md-end="4096">&nbsp;</span
        ><strong data-md-start="4096" data-md-end="4106"
          ><span data-md-start="4098" data-md-end="4104">Cookie</span></strong
        ><span data-md-start="4106" data-md-end="4107">&nbsp;</span
        ><strong data-md-start="4107" data-md-end="4116"
          ><span data-md-start="4109" data-md-end="4114"
            >或标签不受</span
          ></strong
        ><span data-md-start="4116" data-md-end="4117">&nbsp;</span
        ><strong data-md-start="4117" data-md-end="4122"
          ><span data-md-start="4119" data-md-end="4120">&ldquo;</span></strong
        ><span data-md-start="4122" data-md-end="4123">&nbsp;</span
        ><strong data-md-start="4123" data-md-end="4129"
          ><span data-md-start="4125" data-md-end="4127">我们</span></strong
        ><span data-md-start="4129" data-md-end="4130">&nbsp;</span
        ><strong data-md-start="4130" data-md-end="4135"
          ><span data-md-start="4132" data-md-end="4133">&rdquo;</span></strong
        ><span data-md-start="4135" data-md-end="4136">&nbsp;</span
        ><strong data-md-start="4136" data-md-end="4160"
          ><span data-md-start="4138" data-md-end="4158"
            >的控制，而且它们的使用不受本政策的约束。</span
          ></strong
        >
      </p>
    </section>
    <section class="md-section" data-chunk-index="3">
      <p data-md-start="0" data-md-end="209">
        <strong data-md-start="0" data-md-end="5"
          ><span data-md-start="2" data-md-end="3">2</span></strong
        ><span data-md-start="5" data-md-end="6">&nbsp;</span
        ><strong data-md-start="6" data-md-end="11"
          ><span data-md-start="8" data-md-end="9">、</span></strong
        ><span data-md-start="11" data-md-end="12">&nbsp;</span
        ><strong data-md-start="12" data-md-end="17"
          ><span data-md-start="14" data-md-end="15">&ldquo;</span></strong
        ><span data-md-start="17" data-md-end="18">&nbsp;</span
        ><strong data-md-start="18" data-md-end="24"
          ><span data-md-start="20" data-md-end="22">我们</span></strong
        ><span data-md-start="24" data-md-end="25">&nbsp;</span
        ><strong data-md-start="25" data-md-end="30"
          ><span data-md-start="27" data-md-end="28">&rdquo;</span></strong
        ><span data-md-start="30" data-md-end="31">&nbsp;</span
        ><strong data-md-start="31" data-md-end="67"
          ><span data-md-start="33" data-md-end="65"
            >会尽商业上的合理努力去要求这些主体对您的个人信息采取保护措施，但</span
          ></strong
        ><span data-md-start="67" data-md-end="68">&nbsp;</span
        ><strong data-md-start="68" data-md-end="73"
          ><span data-md-start="70" data-md-end="71">&ldquo;</span></strong
        ><span data-md-start="73" data-md-end="74">&nbsp;</span
        ><strong data-md-start="74" data-md-end="80"
          ><span data-md-start="76" data-md-end="78">我们</span></strong
        ><span data-md-start="80" data-md-end="81">&nbsp;</span
        ><strong data-md-start="81" data-md-end="86"
          ><span data-md-start="83" data-md-end="84">&rdquo;</span></strong
        ><span data-md-start="86" data-md-end="87">&nbsp;</span
        ><strong data-md-start="87" data-md-end="104"
          ><span data-md-start="89" data-md-end="102"
            >无法保证这些主体一定会按照</span
          ></strong
        ><span data-md-start="104" data-md-end="105">&nbsp;</span
        ><strong data-md-start="105" data-md-end="110"
          ><span data-md-start="107" data-md-end="108">&ldquo;</span></strong
        ><span data-md-start="110" data-md-end="111">&nbsp;</span
        ><strong data-md-start="111" data-md-end="117"
          ><span data-md-start="113" data-md-end="115">我们</span></strong
        ><span data-md-start="117" data-md-end="118">&nbsp;</span
        ><strong data-md-start="118" data-md-end="123"
          ><span data-md-start="120" data-md-end="121">&rdquo;</span></strong
        ><span data-md-start="123" data-md-end="124">&nbsp;</span
        ><strong data-md-start="124" data-md-end="209"
          ><span data-md-start="126" data-md-end="207"
            >的要求采取保护措施，亦不对这些主体的行为及后果承担任何责任。如果您发现这些第三方创建的网页或第三方开发的应用程序存在风险时，建议您终止相关操作以保护您的合法权益。</span
          ></strong
        >
      </p>
      <p data-md-start="211" data-md-end="226">
        <strong data-md-start="211" data-md-end="216"
          ><span data-md-start="213" data-md-end="214">八</span></strong
        ><span data-md-start="216" data-md-end="217">&nbsp;</span
        ><strong data-md-start="217" data-md-end="226"
          ><span data-md-start="219" data-md-end="224">、适用范围</span></strong
        >
      </p>
      <p data-md-start="228" data-md-end="286">
        <span data-md-start="228" data-md-end="286"
          >本政策适用于您访问&ldquo;我们&rdquo;网站及其相关网站、&ldquo;我们&rdquo;移动设备客户端、POS终端、微信公众号和&ldquo;我们&rdquo;提供的任一服务。</span
        >
      </p>
      <p data-md-start="288" data-md-end="306">
        <strong data-md-start="288" data-md-end="293"
          ><span data-md-start="290" data-md-end="291">九</span></strong
        ><span data-md-start="293" data-md-end="294">&nbsp;</span
        ><strong data-md-start="294" data-md-end="306"
          ><span data-md-start="296" data-md-end="304"
            >、如何与我们联系</span
          ></strong
        >
      </p>
      <p data-md-start="308" data-md-end="383">
        <span data-md-start="308" data-md-end="383"
          >我们已经成立个人信息保护组并配有个人信息保护专门负责人员，如您对本政策存在任何疑问，或对于您的个人信息处理存在任何投诉、意见，请通过以下渠道联系我们：</span
        >
      </p>
      <p data-md-start="385" data-md-end="397">
        <span data-md-start="385" data-md-end="397"
          >1、在线客服：官方公众号</span
        >
      </p>
      <p data-md-start="399" data-md-end="439">
        <span data-md-start="399" data-md-end="439"
          >2、联动优势客服/个人信息保护相关负责人联系电话：致电至400-156-8886</span
        >
      </p>
      <p data-md-start="441" data-md-end="476">
        <span data-md-start="441" data-md-end="476"
          >3、联动优势客服中心联系地址：北京市朝阳区光华路7号汉威大厦西区20层</span
        >
      </p>
      <p data-md-start="478" data-md-end="595">
        <span data-md-start="478" data-md-end="556"
          >您可随时登录您的&ldquo;我们&rdquo;账户查询并管理该账户下您的个人信息，如您遇到任何障碍或疑问，可联系&ldquo;我们&rdquo;客服【400-156-8886】。如您不满意我们的答复，&nbsp;</span
        ><strong data-md-start="556" data-md-end="595"
          ><span data-md-start="558" data-md-end="593"
            >有权将争议提交至北京仲裁委员会按照其现行有效的仲裁规则在北京进行仲裁。</span
          ></strong
        >
      </p>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.content-box {
  // width: 100%;
  margin: 30px;
  padding-bottom: 30px;
  word-break: break-all;
  table {
    border-collapse: collapse;
    width: 100%;
  }
}
</style>
